import axios from 'axios';
import { getAdminToken, getCustomerToken } from './session';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

export function authHeaders(token?: string | null) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export function adminAuthHeaders() {
  return authHeaders(getAdminToken());
}

export function customerAuthHeaders() {
  return authHeaders(getCustomerToken());
}

export function adminMultipartHeaders() {
  return {
    headers: {
      Authorization: `Bearer ${getAdminToken()}`,
      'Content-Type': 'multipart/form-data',
    },
  };
}
